/*
shell.controller.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
/**
 * The launcher is a controller that is responsible for the lifecycle of the modules in the system.
 * There are four states in the modules lifecycle: launched, visible, not visible and closed.
 */
define('modules/shell/controllers/shell.controller',[
    'lodash',
    'system-config',
    '../module',
    '../services/application.service'
], function (_, systemConfig, shell) {
    'use strict';

    shell.run(['$Endpoint', function ($Endpoint) {
        $Endpoint.init();
    }]);

    shell.controller('ShellCtrl', ['$scope', '$rootScope', '$transitions', 'uaf.appshell.AppConfig', function ($scope, $rootScope, $transitions, appConfig) {
        $scope.moduleTransitioning = false;

        $transitions.onStart({}, function (transition) {
            var fromModule = appConfig.getModuleByState(transition.$from().name);
            var toModule = appConfig.getModuleByState(transition.$to().name);

            $scope.setModuleTransitioningByParameters(fromModule, toModule);
        });

        $scope.setModuleTransitioningByParameters = function (fromModule, toModule) {
            if ((fromModule !== toModule) && sessionStorage['parsingIsInprogress'] === undefined) {
                $scope.moduleTransitioning = true;
            }
        };

        var transitionFinished = function () {
            $scope.moduleTransitioning = false;
            sessionStorage.removeItem('parsingIsInprogress');
        };

        $transitions.onSuccess({}, function () {
            transitionFinished();
        });
        $transitions.onError({}, function () {
            transitionFinished();
        });
    }]);
});

